import React from 'react';
import ReactDOM from 'react-dom/client';   
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiConfig } from 'wagmi';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WalletProvider } from '@solana/wallet-adapter-react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { config } from './wagmi-config';
import './index.css';

const queryClient = new QueryClient();
const wallets = [new PhantomWalletAdapter()];
const network = WalletAdapterNetwork.Mainnet;

const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(
  <React.StrictMode>
    <WagmiConfig config={config}>
      <QueryClientProvider client={queryClient}>
        <WalletProvider wallets={wallets} autoConnect={false} network={network}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </WalletProvider>
      </QueryClientProvider>
    </WagmiConfig>
  </React.StrictMode>
);
